export const seasonData = [
  {
    Id: 0,
    Name: "كلاهما",
    NameEn: "Both",
  },
  {
    Id: 1,
    Name: "الصيف",
    NameEn: "summer",
  },
  {
    Id: 2,
    Name: "الشتاء",
    NameEn: "winter",
  },
];
export const elements = [
  {
    Id: 0,
    Name: "اكسسوارات",
    NameEn: "Accessory",
  },
  {
    Id: 1,
    Name: "خامة",
    NameEn: "Material",
  },
  {
    Id: 2,
    Name: "تصميم",
    NameEn: "Design",
  },
];
export const Gender = [
  {
    Id: 0,
    Name: "غير معروف",
    NameEn: "None",
  },
  {
    Id: 1,
    Name: "ذكر",
    NameEn: "Male",
  },
  {
    Id: 2,
    Name: "أنثى",
    NameEn: "Female",
  },
];
export const InfarctionType = [
  {
    Id: 0,
    Name: "غير معروف",
    NameEn: "None",
  },
  {
    Id: 1,
    Name: "STEMI",
    NameEn: "STEMI",
  },
  {
    Id: 2,
    Name: "NSTEMI",
    NameEn: "NSTEMI",
  },
];

export const Result = [
  {
    Id: 0,
    Name: "غير معروف",
    NameEn: "None",
  },
  {
    Id: 1,
    Name: "نجاح",
    NameEn: "Success",
  },
  {
    Id: 2,
    Name: "فشل",
    NameEn: "Failure",
  },
];
export const ETF = [
  {
    Id: 0,
    Name: "غير معروف",
    NameEn: "None",
  },
  {
    Id: 1,
    Name: "نعم",
    NameEn: "Yes",
  },
  {
    Id: 2,
    Name: "لا",
    NameEn: "No",
  },
];
export const pos_neg = [
  {
    Id: 0,
    Name: "غير معروف",
    NameEn: "None",
  },
  {
    Id: 1,
    Name: "إيجابي",
    NameEn: "Positive",
  },
  {
    Id: 2,
    Name: "سلبي",
    NameEn: "Negative",
  },
];
export const ResidencyArea = [
  {
    Id: 0,
    Name: "غير معروف",
    NameEn: "None",
  },
  {
    Id: 1,
    Name: "حضري",
    NameEn: "Urban",
  },
  {
    Id: 2,
    Name: "ريفي",
    NameEn: "Rural",
  },
];
export const SmokerHistory = [
  {
    Id: 0,
    Name: "غير معروف",
    NameEn: "None",
  },
  {
    Id: 1,
    Name: "المدخن",
    NameEn: "Smoker",
  },
  {
    Id: 2,
    Name: "مدخن سابق",
    NameEn: "Former Smoker",
  },
  {
    Id: 3,
    Name: "لم يدخن",
    NameEn: "Never Smoked",
  },
];
export const EducationLevel = [
  {
    Id: 0,
    Name: "غير معروف",
    NameEn: "None",
  },
  {
    Id: 1,
    Name: "مدرسة",
    NameEn: "School",
  },
  {
    Id: 2,
    Name: "كلية",
    NameEn: "College",
  },
  {
    Id: 3,
    Name: "درجة الماجستير أو الدكتوراه",
    NameEn: "Masters Or PhD degrees",
  },
];
export const ApproachCoronaryAngiography = [
  {
    Id: 0,
    Name: "غير معروف",
    NameEn: "None",
  },
  {
    Id: 1,
    Name: "عبر شعاعي",
    NameEn: "Trans Radial",
  },
  {
    Id: 2,
    Name: "فخذي",
    NameEn: "Femoral",
  },
];
export const ResultCoronaryAngiography = [
  {
    Id: 0,
    Name: "غير معروف",
    NameEn: "None",
  },
  {
    Id: 1,
    Name: "طبيعي",
    NameEn: "Normal",
  },
  {
    Id: 2,
    Name: "طبيعي",
    NameEn: "Normal",
  },
  {
    Id: 3,
    Name: "غير طبيعي",
    NameEn: "Abnormal",
  },
];
export const IfAbnormal = [
  {
    Id: 0,
    Name: "غير معروف",
    NameEn: "None",
  },
  {
    Id: 1,
    Name: "إكتاسيا",
    NameEn: "Ectasia",
  },
  {
    Id: 2,
    Name: "التدفق البطيء",
    NameEn: "Slow Flow",
  },
  {
    Id: 3,
    Name: "جسر عضلة القلب",
    NameEn: "Myocardial Bridge",
  },
  {
    Id: 4,
    Name: "آفة",
    NameEn: "Lesion",
  },
];
export const IfLesion70 = [
  {
    Id: 0,
    Name: "غير معروف",
    NameEn: "None",
  },
  {
    Id: 1,
    Name: "سفينة واحدة",
    NameEn: "One Vessel",
  },
  {
    Id: 2,
    Name: "سفينتان",
    NameEn: "Two Vessels",
  },
  {
    Id: 3,
    Name: "ثلاث سفن",
    NameEn: "Three Vessels",
  },
  {
    Id: 4,
    Name: "أكثر من ثلاث سفن",
    NameEn: "More Than Three Vessels",
  },
];
export const CoronaryAngiographyRecommendation = [
  {
    Id: 0,
    Name: "غير معروف",
    NameEn: "None",
  },
  {
    Id: 1,
    Name: "علاج طبي",
    NameEn: "Medical Therapy",
  },
  {
    Id: 2,
    Name: "تدخل",
    NameEn: "Intervention",
  },
  {
    Id: 3,
    Name: "CABG",
    NameEn: "CABG",
  },
];
export const NumberOfStents = [
  {
    Id: 0,
    Name: "غير معروف",
    NameEn: "None",
  },
  {
    Id: 1,
    Name: " واحد",
    NameEn: "One",
  },
  {
    Id: 0,
    Name: "اثنين",
    NameEn: "Two",
  },
  {
    Id: 1,
    Name: "ثلاثة",
    NameEn: "Three",
  },
  {
    Id: 1,
    Name: "أكثر",
    NameEn: "More",
  },
];

export const Infarction = [
  {
    Id: 0,
    Name: "غير معروف",
    NameEn: "None",
  },
  {
    Id: 1,
    Name: "أمامي الحاجز",
    NameEn: "Anteroseptal",
  },
  {
    Id: 2,
    Name: "السفلي ",
    NameEn: "Inferior",
  },
  {
    Id: 3,
    Name: "الجانبي",
    NameEn: "Lateral",
  },
  {
    Id: 4,
    Name: "آخر",
    NameEn: "Other",
  },
];
export function getUniqueListBy(arr, key) {
  return arr.filter(
    (v, i, a) => a.findLastIndex((v2) => v2[key] === v[key]) === i
  );
}
